// extracted by mini-css-extract-plugin
module.exports = {"roundedImage":"asset-image_roundedImage__lgk_A"};